import { render, staticRenderFns } from "./PalletPage.vue?vue&type=template&id=18124186&scoped=true"
import script from "./PalletPage.vue?vue&type=script&lang=js"
export * from "./PalletPage.vue?vue&type=script&lang=js"
import style0 from "./PalletPage.vue?vue&type=style&index=0&id=18124186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18124186",
  null
  
)

export default component.exports